import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-omgevingsvisie',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconOmgevingsvisie {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M19.04 11.6c.98-1.84.96-3.95-.1-5.48-.85-1.24-2.25-1.95-3.84-1.95-.4 0-.8.04-1.2.13-1.2-1.38-2.83-2.18-4.46-2.18-1.04 0-2.02.33-2.82.96a4.85 4.85 0 0 0-1.47 2.01c-2.92.3-5.16 2.85-5.16 5.99 0 1.76.74 3.42 1.99 4.56a4.97 4.97 0 0 0-.26 1.57c0 2.68 2.08 4.85 4.64 4.85.51 0 1.27-.02 1.69-.06l-.02 2.96-2.06-.92-.94 2.44 3.02 1.38-.06 8.12 3.98.02V21.84c.53.1.97.21 1.92.21 3.47 0 6.3-2.97 6.3-6.62 0-1.69-.58-2.98-1.17-3.84h.02Zm2.68-2.15.28.37 1.04-.94v4.06c5.92 0 9.97 1.37 9.97 1.37V8.95l1.03.9 1.82-2.38-2.85-2.44V.96h-2.99v1.68L27.93.81l-6.59 5.62c.35.95.47 1.97.38 3.01ZM26 6.99h4v3h-4zm10 11.44c-6.49-3.46-11.92-3.56-13.82-3.46 0 .19.03.37.03.56 0 .6-.05 1.18-.14 1.75 1.5-.09 7.24-.12 13.93 3.71zm-2.13 17.56h2.1C32.68 25.1 24.73 21.54 20.68 20.43a8.59 8.59 0 0 1-1.5 1.68c2.99.62 11.23 3.29 14.69 13.88"/>
</svg>

    );
  }
}
